import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

export default function PaymentSuccess() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const courseId = searchParams.get("courseId");

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f6f9fc",
                p: 2,
            }}
        >
            <Box
                sx={{
                    background: "#fff",
                    width: "100%",
                    maxWidth: "500px",
                    borderRadius: "16px",
                    p: 5,
                    textAlign: "center",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
                }}
            >
                <Box
                    sx={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        background: "#e8f8ef",
                        color: "#16a34a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "45px",
                        margin: "0 auto 20px",
                    }}
                >
                    ✓
                </Box>

                <Typography
                    variant="h4"
                    fontWeight="bold"
                    mb={2}
                >
                    Payment Successful!
                </Typography>

                <Typography
                    color="text.secondary"
                    mb={4}
                >
                    Your payment has been verified successfully.
                    You are now enrolled in this course.
                </Typography>

                <Button
                    variant="contained"
                    fullWidth
                    onClick={() => navigate(`/courses`)}
                    sx={{
                        py: 1.5,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "16px",
                        fontWeight: 600,
                    }}
                >
                    Start Learning
                </Button>
            </Box>
        </Box>
    );
}